import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/properties/')({
	component: () => <Navigate to="/properties/registry" />,
})
